export const getUpdateSingleSeriesPayload = (values) => {
    const getCoverImageResource = () => {
        if (!values.coverImage) {
            return {
                type: 'Remove',
            };
        }
        if (values.coverImageResourceId) {
            return {
                type: 'New',
                id: values.coverImageResourceId,
            };
        }
        return {
            type: 'Keep',
        };
    };
    const getThumbnailResource = () => {
        if (!values.thumbnailImage) {
            return {
                type: 'Remove',
            };
        }
        if (values.thumbnailImageResourceId) {
            return {
                type: 'New',
                id: values.thumbnailImageResourceId,
            };
        }
        return {
            type: 'Keep',
        };
    };
    return {
        title: values.title,
        description: values.description || '',
        coverImageResource: getCoverImageResource(),
        thumbnailResource: getThumbnailResource(),
    };
};
